<template>
  <section class="section text-center" v-if="!isLoading" >
    <i class="icon-style" v-if="icon" :class="icon"
      :style="{color:iconColor}"
    ></i>
    <img v-else :src="`img/dino/${image}.svg`" class="empty-image" />
    <p class="text-style" :style="{color:textColor}" >{{message}}</p>
  </section>
  <section class="section text-center" v-else>
    <i class="icon-style k-icon-spin4 animate-spin"
      :style="{color:iconColor}"
    ></i>
    <p class="text-style" :style="{color:textColor}" >{{ $t("message.data_loading") }}</p>
  </section>
</template>
<script>
export default {
  name:'empty-data',
    props:{
      icon : {
        type:String,
        default:null
      },
      message : String,
      iconColor:String,
      textColor:String,
      isLoading: Boolean,
      image:{
        type:String,
        default:null
      }
    }
}
</script>
<style scoped>
.icon-style{
  font-size: 7rem;
}
.text-style{
  font-size: 1.5rem;
  font-weight: 800;
}
.empty-image{
  max-width: 160px;
  padding-bottom: 20px;
}
</style>